import { useCases } from "@/data/content";
import { CORPORATE } from "@/constants/testIds";
import { ArrowRight } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function CorporateEvents() {
  return (
    <section
      id="corporate"
      data-testid={CORPORATE.section}
      className="py-20 md:py-28 bg-[var(--aura-ivory-2)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <span className="eyebrow">Corporate · Private</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">
            Bring Aura to your workplace, community, or private gathering
          </h2>
          <p className="mt-5 font-body text-[var(--aura-charcoal-2)] leading-relaxed">
            Aura can design custom events for companies, communities,
            institutions, clubs, coworking spaces, and private groups.
          </p>
          <button
            onClick={() => scrollTo("enquiry")}
            data-testid={CORPORATE.cta}
            className="mt-8 inline-flex items-center gap-2 font-ui text-sm px-6 py-3 rounded-full bg-[var(--aura-teal)] text-[var(--aura-ivory)] hover:bg-[var(--aura-teal-hover)] transition-colors"
          >
            Request a Custom Event <ArrowRight size={16} />
          </button>
        </div>

        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
          {useCases.map((u, i) => (
            <div
              key={u.title}
              className="p-6 rounded-2xl bg-white border border-black/5 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              <div className="font-display text-xs text-[var(--aura-teal)] tracking-widest">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="mt-2 font-display text-xl leading-snug">
                {u.title}
              </h3>
              <p className="mt-2 font-body text-sm text-[var(--aura-charcoal-2)] leading-relaxed">
                {u.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
